

import { Component, Vue } from 'vue-property-decorator';


@Component
export default class CPDocumentModal extends Vue {

  public loading: boolean = false;

  public close() {
    this.$store.commit('toggleBuyBasket', false);
  }

  public beforeDestroy() {
    this.$store.commit('updateDealingInstructions', null);
  }

}
